import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.kreonet.placeholder.user');
import { OnInit } from '@angular/core';

@Component({
    selector: 'wiz-portal-kreonet-placeholder-user',
template: templateSource || '',
    styles: [``],
})
export class PortalKreonetPlaceholderUserComponent implements OnInit {
    public ngOnInit() {
    }
}

export default PortalKreonetPlaceholderUserComponent;